require('./bootstrap');

import { createApp } from "vue";
import router from "./router";
import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
import VueClipboard from 'vue-clipboard2'
import axios from 'axios';
import VueAxios from 'vue-axios'

//ADMIN 
import ListarObras from "./components/admin/obras/Listar.vue";

import PrimeVue from 'primevue/config';

//OPÇÃO 3
const vue = createApp({
    components: {}
})

vue.use(PrimeVue)
vue.use(VueAxios, axios)
vue.use(VueClipboard)
vue.use(VueSweetalert2);
vue.use(router)

//ADMIN LISTAR OBRAS
vue.component('listar-obras', ListarObras)

vue.mount("#app")